import { Box, css, Grid, styled, TextField } from '@mui/material';
import { DatePicker, TimeField } from '@mui/x-date-pickers';

import { GeocodingSearchInput } from '@/components/routing/GeocodingSearchInput';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { RouteLocationType } from '@/types/RouteLocationType';
import { TimeType } from '@/types/TimeType';

const StyledGrid = styled(Grid)(
  ({ theme }) => css`
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(2)};
    padding: ${theme.spacing(1, 0)};
  `,
) as typeof Grid;

const StyledGridItem = styled(Grid)(
  () => css`
    & .MuiTextField-root {
      width: 100%;
    }
  `,
) as typeof Grid;

export function RoutingForm() {
  const time = useRoutesStore((state) => state.time);
  const { updateTime } = useRoutesStore((state) => state.actions);

  return (
    <Box>
      <form>
        <GeocodingSearchInput label="Start" routeLocationType={RouteLocationType.ORIGIN} />
        <GeocodingSearchInput label="Ziel" routeLocationType={RouteLocationType.DESTINATION} />
        <StyledGrid container spacing={1}>
          <StyledGridItem size={4}>
            <TextField
              fullWidth
              select
              value={time.type}
              variant="standard"
              onChange={(event) => {
                updateTime({ type: event.currentTarget.value as TimeType });
              }}
              slotProps={{
                select: {
                  native: true,
                },
              }}
            >
              <option value={TimeType.DEPARTURE}>Abfahrt</option>
              <option value={TimeType.ARRIVAL}>Ankunft</option>
            </TextField>
          </StyledGridItem>
          <StyledGridItem size={3}>
            <TimeField
              format="HH:mm"
              slotProps={{ textField: { variant: 'standard' } }}
              value={time.date}
              onChange={(value) => {
                if (value) {
                  updateTime({ date: value });
                }
              }}
            />
          </StyledGridItem>
          <StyledGridItem size={5}>
            <DatePicker
              format="DD.MM.YYYY"
              value={time.date}
              onChange={(value) => {
                if (value) {
                  updateTime({ date: value });
                }
              }}
              slotProps={{
                textField: { variant: 'standard' },
                openPickerButton: {
                  sx: { margin: '0px -12px 0px 0px' },
                },
              }}
            />
          </StyledGridItem>
        </StyledGrid>
      </form>
    </Box>
  );
}
